<template lang="pug">
  .athlete-card-wrapper
    .athlete-card(v-for="athlete in athletes")
      .col-1
        .rank(:class="athlete.placement === undefined && 'loading'" v-if="athlete.placement !== 0") {{athlete.placement}}
      .col-2
        .thumbnail
          StaticImage.thumb(
            :src="athlete.thumb"
            alt=""
            :height="115"
            :width="115"
            background="#ffffff"
          )
      .col-3
        .rank-mobile
          span(v-if="athlete.placement !== 0") {{athlete.placement}}.
          span {{ athlete.name }}
        .name(:class="!athlete.name && 'loading'") {{athlete.name || ' '}}
        .flag(v-if="athlete.country")
          img(
            :src="getCloudinaryUrl(`/cms/rogue%20challenge/flags/${athlete.country}.svg`)"
            :alt="flagAlt(athlete.country, $rogue)"
            height="17"
          )
        .points(:class="athlete.points === undefined && 'loading'" v-if="athlete.points !== 0") {{athlete.points}}
</template>
<script setup lang="ts">
import { flagAlt, getCloudinaryUrl } from '../../js/helpers'
defineProps({
  athletes: {
    type    : Array,
    default : () => ([]),
  },
})
</script>

<style lang="scss" scoped>
.athlete-card-wrapper {
  display: flex;
  flex-direction: row;
  height: 100px;

  @include mobile() {
    height: 101px;
  }

  .athlete-card {
    width: 215px;
    max-width: 215px;
    display: flex;
    border-right: 0.5px solid $color-gray;
    border-left: 0.5px solid $color-gray;
    border-bottom: 1px solid $color-gray;
    padding: $size-s;

    @include mobile() {
      width: 92px;
      height: 101px;
      flex-direction: column;
      padding: 0;
      justify-content: center;
      align-items: center;
      border: none;
    }

    .col-1,
    .col-2,
    .col-3 {
      display: flex;
      flex-direction: column;
    }

    .col-1 {
      @include mobile() {
        display: none;
      }
    }

    .col-2 {
      margin-right: $space-xs;
      margin-left: $space-xxs;

      @include mobile() {
        margin: 0;
      }
    }

    .name {
      margin-bottom: $space-xxxs;
      font-size: $size-xs;
      font-weight: $weight-bold;

      @include mobile() {
        display: none;
      }
    }

    .rank {
      font-weight: $weight-bold;
    }

    .rank-mobile {
      font-size: $size-xxs;
      font-weight: $weight-bold;

      @include not-mobile() {
        display: none;
      }
    }

    .thumbnail {
      width: 70px;
      max-width: 70px;

      @include mobile() {
        width: 56px;
        max-width: 56px;
        margin-bottom: $space-xxxs;
      }
    }

    .flag {
      margin-bottom: $space-xxs;

      @include mobile() {
        display: none;
      }

      img {
        display: block;
        width: auto;
        max-height: 17px;
      }
    }

    .points {
      font-size: $size-xxs;

      @include mobile() {
        display: none;
      }
    }
  }
}

.loading {
  background-color: $color-gray-light;
  width: 100%;
  display: block;
  min-height: 16px;
}
</style>
